import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { i8888to32 as r } from "./number.js";
var n = [255, 255, 255, 1],
    t = [0, 0, 0, 0];

function u(r, n) {
  return Array.isArray(n) ? (r[0] = n[0], r[1] = n[1], r[2] = n[2], r[3] = n[3]) : (r[0] = n.r, r[1] = n.g, r[2] = n.b, r[3] = n.a), r;
}

function o(r) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var u = r[n + 3];
  return r[n + 0] *= u, r[n + 1] *= u, r[n + 2] *= u, t || (r[n + 3] *= 255), r;
}

function c(r) {
  return o(u([], r));
}

function e(n) {
  return o(u(t, n)), r(t[0], t[1], t[2], t[3]);
}

function i(n) {
  if (!n) return 0;
  var t = n.r,
      u = n.g,
      o = n.b,
      c = n.a;
  return r(t * c, u * c, o * c, 255 * c);
}

function f(n) {
  if (!n) return 0;

  var _n = _slicedToArray(n, 4),
      t = _n[0],
      u = _n[1],
      o = _n[2],
      c = _n[3];

  return r(t * (c / 255), u * (c / 255), o * (c / 255), c);
}

export { c as copyAndPremultiply, o as premultiplyAlpha, i as premultiplyAlphaRGBA, f as premultiplyAlphaRGBAArray, e as premultiplyAlphaUint32, n as white };